import { getRoles, createRole, updateRole, deleteRole } from '../models/roleModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from 'svelte-toasts';

export async function fetchRoles(page, perPage) {
  try {
    const response = await getRoles(page, perPage);
    return {
      role: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching roles:", error);
    Swal.fire('Error', 'No se pudieron cargar los roles', 'error');
    return null;
  }
}

export async function saveRole(role, currentRoleId) {
  try {
    if (currentRoleId) {
      await updateRole(currentRoleId, role);
      toasts.add({
        title: 'Éxito',
        description: 'Rol guardado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      await createRole(role);
      toasts.add({
        title: 'Éxito',
        description: 'Rol creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }
  } catch (error) {
    console.error("Error saving role:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el rol',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

export async function removeRole(id) {
  try {
    await deleteRole(id);
    toasts.add({
      title: 'Éxito',
      description: 'Rol eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error("Error deleting role:", error);
    Swal.fire('Error', 'No se pudo eliminar el rol', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'role'
export function subscribeToRoles(searchQuery, handleSearch) {
  pb.collection('role').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromRoles() {
  pb.collection('role').unsubscribe('*');
}

export async function searchRoles(query, page = 1, perPage = 10) {
  const response = await pb.collection('role').getList(page, perPage, {
    filter: `descrip ~ "${query}"`,
  });
  return {
    role: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}